import apiConfig from "constants/apiConfig"
import axiosClient from "utils/axiosClient"

export const fetchRegions = async (agencyId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_REGIONS.url.replace('<agencyId>', agencyId));
    return response.data.results;
}

export const fetchAgencyMaster = async (agencyId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_AGENCY_MASTER.url.replace('<agencyId>', agencyId));
    return response.data.master;
}